import {OAuthState} from '../reducers/oauth.reducer';
import {safelyToJS} from './utils';

export const selectOAuth = (state): OAuthState => safelyToJS(state.get('oauth'));
